import React, { useState } from "react";
import { Maximize2, X } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { CollapsibleSection, fmtTL } from "./CollapsibleSection";
import { PeriodDetailList } from "./PeriodDetailList";

const PERIODS = [
  { key: "daily", label: "Günlük", hint: "Bugün", color: "text-green-600" },
  { key: "monthly", label: "Aylık", hint: "Bu ay", color: "text-blue-600" },
  { key: "yearly", label: "Yıllık", hint: "Bu yıl", color: "text-purple-600" },
];

const PeriodCard = ({ period, value, active, icon, onClick, testId }) => (
  <Card
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
    className={`cursor-pointer transition-shadow hover:shadow-md ${active ? "ring-2 ring-blue-500" : ""}`}
    data-testid={testId}
  >
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle className="text-xs font-medium text-gray-600 uppercase tracking-wide">{period.label}</CardTitle>
      {icon}
    </CardHeader>
    <CardContent>
      <div className={`text-lg font-bold ${period.color}`}>{fmtTL(value)}</div>
      <p className="text-xs text-gray-500 mt-1">{period.hint} • {active ? "Listeyi gizle" : "İşlemleri gör"}</p>
    </CardContent>
  </Card>
);

export const PeriodStatSection = ({ id, title, icon, titleClass, category, values = {}, api, sessionToken }) => {
  const [selected, setSelected] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const current = PERIODS.find((p) => p.key === selected);

  return (
    <CollapsibleSection id={id} title={title} icon={icon} titleClass={titleClass} summary={`Bugün ${fmtTL(values.daily)}`}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PERIODS.map((p) => (
          <PeriodCard
            key={p.key}
            period={p}
            value={values[p.key]}
            active={selected === p.key}
            icon={icon}
            onClick={() => setSelected(selected === p.key ? null : p.key)}
            testId={`dash-${category}-${p.key}-card`}
          />
        ))}
      </div>
      {current && (
        <div className="mt-4 border rounded-lg p-3 bg-gray-50" data-testid={`dash-${category}-inline`}>
          <div className="flex items-center justify-between mb-2">
            <h3 className="font-semibold text-sm">{title} • {current.label} İşlemler</h3>
            <div className="flex gap-1">
              <Button size="sm" variant="outline" onClick={() => setDialogOpen(true)} data-testid={`dash-${category}-open-dialog`}>
                <Maximize2 className="h-4 w-4 mr-1" /> Pencerede Aç
              </Button>
              <Button size="sm" variant="ghost" onClick={() => setSelected(null)} data-testid={`dash-${category}-close-inline`}>
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <PeriodDetailList api={api} sessionToken={sessionToken} category={category} period={current.key} perPage={10} testIdPrefix={`dash-${category}-list`} />
        </div>
      )}
      <Dialog open={dialogOpen && !!current} onOpenChange={setDialogOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid={`dash-${category}-dialog`}>
          <DialogHeader>
            <DialogTitle>{title} • {current?.label} İşlemler</DialogTitle>
            <DialogDescription>{current?.hint} yapılan tüm işlemler</DialogDescription>
          </DialogHeader>
          {current && (
            <PeriodDetailList api={api} sessionToken={sessionToken} category={category} period={current.key} perPage={50} testIdPrefix={`dash-${category}-dialog-list`} />
          )}
        </DialogContent>
      </Dialog>
    </CollapsibleSection>
  );
};
